module.exports = __webpack_public_path__ + "img/worteltaart-beslag-met-bloem.43151d46.jpg";